import { gql } from '@apollo/client';

export const CREATE_MESSAGE_THREAD = gql`
  mutation CreateMessageThread($toolId: ID!, $toolBookingId: ID, $participantIds: [ID!]) {
    createMessageThread(toolId: $toolId, toolBookingId: $toolBookingId, participantIds: $participantIds) {
      messageThread {
        id
        subject
        participants {
          id
          name
        }
        tool {
          id
          name
        }
      }
      errors
    }
  }
`;

export const CREATE_MESSAGE_THREAD_INPUT = gql`
  mutation CreateMessageThreadInput($toolId: ID!, $toolBookingId: ID, $participantIds: [ID!]) {
    createMessageThread(input: { toolId: $toolId, toolBookingId: $toolBookingId, participantIds: $participantIds }) {
      messageThread {
        id
        subject
        participants {
          id
          name
        }
        tool {
          id
          name
        }
      }
      errors
    }
  }
`;
